import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { analytics } from '@lib/analytics'
import { useAuth } from '@/contexts/AuthContext'
import { useWorkspaceStore } from '@stores/workspace-store'

export function PostHogTracker(): null {
  const location = useLocation()
  const { user } = useAuth()
  const storeWorkspaceId = useWorkspaceStore((s) => s.activeWorkspaceId)
  const activeWorkspaceId = storeWorkspaceId || user?.workspaceId || null

  // Identify user across all analytics providers (PostHog + GTM).
  // PostHog identified_only mode requires identify() before group().
  useEffect(() => {
    if (user) {
      analytics.identify(user.id, activeWorkspaceId ?? undefined, user.email, user.workspaceName)
    }
  }, [user?.id, activeWorkspaceId, user?.email])

  // Pageview tracking — captures for all visitors (anonymous + authenticated).
  // With identified_only mode, anonymous events are aggregated without
  // creating person profiles. Only identified users get person profiles.
  useEffect(() => {
    analytics.trackPageView(location.pathname + location.search)
  }, [location.pathname, location.search])

  return null
}
